import Tooltip from '@atlaskit/tooltip';
import { timeFormat } from 'd3';
import { useRef } from 'react';
import { element } from '../../../core/elements';
import { jsx as _jsx } from "react/jsx-runtime";
const TRUNCATE_STYLES = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};
export const TickText = element(props => {
  // TODO: Force singleline
  const {
    formatter,
    style,
    truncate,
    singleline,
    children
  } = props;
  const ref = useRef(null);
  const truncateStyles = truncate ? TRUNCATE_STYLES : {};
  const tickContent = typeof formatter === 'function' ? formatter(children) : timeFormat(formatter)(children);
  return /*#__PURE__*/_jsx(Tooltip, {
    tag: 'div',
    position: "bottom",
    content: tickContent,
    canAppear: () => {
      const element = ref.current;
      if (!element) return false;
      return element.offsetWidth < element.scrollWidth;
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      style: {
        ...style,
        ...truncateStyles,
        pointerEvents: 'auto'
      },
      children: /*#__PURE__*/_jsx("span", {
        children: tickContent
      })
    })
  });
});